import type {
  OrderCodeSignature,
  LastChange,
  OrderCodePart,
  OrderCodePartOption,
  ProductInput,
} from "../product.types";

export type SelectPart = {
  partKey: OrderCodePart["key"];
  optionKey: OrderCodePartOption["key"];
  signatureKey: OrderCodeSignature["key"];
  input: ProductInput;
};

export const selectPart = ({
  partKey,
  optionKey,
  signatureKey,
  input,
}: SelectPart) => {
  if (!input?.state || !input?.state?.orderCodeState) {
    throw new Error("Input state or orderCodeState is missing");
  }
  const change: LastChange = {
    partKey: partKey,
    optionKey: optionKey,
    signatureKey: signatureKey,
  };
  input.state.orderCodeState = {
    ...input.state.orderCodeState,
    lastChange: change,
  };
};
